import React from "react";
import { LegalPage } from "@/components/LegalPage";
import { useSeo } from "@/lib/seo";

export default function Accessibility() {
  useSeo({
    title: "Accessibility Statement | Meridian Dental Studio",
    description: "Meridian Dental Studio is committed to digital accessibility and WCAG 2.1 compliance. Learn how to reach us for accessibility support and feedback.",
    path: "/accessibility",
  });

  return (
    <LegalPage
      eyebrow="Legal"
      title="Accessibility Statement"
      updated="June 2026"
      intro="Meridian Dental Studio is committed to ensuring our website is accessible to everyone, including people with disabilities. We are continually working to improve the experience for all users."
      sections={[
        {
          h: "1. Our commitment",
          p: [
            "We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. These guidelines explain how to make web content more accessible to people with a wide range of disabilities, including visual, auditory, motor and cognitive impairments.",
          ],
        },
        {
          h: "2. Measures we take",
          p: ["Our ongoing efforts include:"],
          list: [
            "Semantic HTML, clear heading structure and descriptive image alternative text.",
            "Sufficient color contrast and readable, scalable typography.",
            "Keyboard-navigable interfaces and visible focus states.",
            "Touch-friendly targets and a mobile-first, responsive layout.",
          ],
        },
        {
          h: "3. Ongoing improvement",
          p: [
            "Digital accessibility is an ongoing effort. We regularly review the website and address issues as technology and standards evolve. Some third-party content or tools may not yet fully meet our accessibility standards, and we work with our partners to improve them.",
          ],
        },
        {
          h: "4. Accessibility support & feedback",
          p: [
            "If you encounter any accessibility barrier on our website, or need assistance accessing information or booking an appointment, we want to help. Please contact us at hello@meridiandentalstudio.com or call (212) 555-0142. We welcome your feedback and will make reasonable efforts to provide the information or service you need through an alternative method.",
          ],
        },
      ]}
    />
  );
}
